module.exports = __webpack_public_path__ + "img/clouds.c8f3fe6f.svg";